export default class InspectionFilters {
  constructor({ commonFilters = {}, headerFilters = [] } = {}) {
    this.commonFilters = commonFilters; // e.g. { status: { value: [...], operator: "IN" } }
    this.headerFilters = headerFilters; // array of headerFilter objects
  }

  static fromServerModel(serverModel = {}) {
    const { commonFilters = {}, headerFilters = [] } = serverModel;
    return new InspectionFilters({ commonFilters, headerFilters });
  }

  toServerModel() {
    return {
      commonFilters: this.commonFilters,
      headerFilters: this.headerFilters,
    };
  }
}
